import * as fromActions from '../actions/hotel.actions';

export const initialState = 'default';

export function reducer(state = initialState, action: fromActions.HotelActions): string {
  switch (action.type) {
    case fromActions.RESTORE_HOTEL_RESULTS_LAYOUT_SUCCESS:
    case fromActions.SET_HOTEL_RESULTS_LAYOUT_SUCCESS:
      return action.payload;

    default:
      return state;
  }
}
